const levelOptions = [
  { label: '一级标签', value: 1 },
  { label: '二级标签', value: 2 },
];

function requiredText(message) {
  return {
    required: true,
    trigger: ['blur', 'change'],
    message,
    validator: (rule, value, callback) => {
      value && String(value).trim() ? callback() : callback(new Error(message));
    },
  };
}

function createParentGameField() {
  const field = {
    label: '游戏',
    type: 'select-tree',
    props: {
      style: { width: '300px' },
      options: [],
      ischeckbox: false,
      'check-on-click-node': true,
      props: {
        value: 'id',
        label: 'name',
        children: 'children',
      },
      'select-props': {
        placeholder: '请选择游戏',
        size: 'mini',
        clearable: true,
        accordion: true,
      },
    },
    value: null,
    rules: requiredText('请选择游戏'),
  };
  field.on = {
    getValue: (value) => {
      field.value = value;
    },
  };
  return field;
}

function createLabelField() {
  return {
    label: '标签',
    type: 'input',
    props: {
      placeholder: '请输入标签',
      maxlength: 10,
      'show-word-limit': true,
      clearable: true,
    },
    value: '',
    rules: [
      requiredText('请输入标签！'),
      {
        maxLength: 10,
        trigger: ['blur', 'change'],
        validator: (rule, value, callback) => {
          value && value.length <= rule.maxLength ? callback() : callback(new Error(`每个标签最大长度限制${rule.maxLength}个字`));
        },
      },
    ],
  };
}

function createRemarkField() {
  return {
    label: '标签说明',
    type: 'input',
    props: {
      type: 'textarea',
      autosize: { minRows: 3, maxRows: 6 },
      placeholder: '请输入标签说明',
    },
    value: '',
    rules: requiredText('请输入标签说明！'),
  };
}

function createLevelField() {
  return {
    label: '标签等级',
    type: 'select',
    options: levelOptions,
    props: {
      placeholder: '请选择标签等级',
      clearable: true,
    },
    rules: requiredText('请选择标签等级'),
    value: '',
  };
}

function createAddFormConfig() {
  return {
    parent_game_id: createParentGameField(),
    label: createLabelField(),
    remark: createRemarkField(),
    level: createLevelField(),
  };
}

function createEditFormConfig() {
  return {
    label: createLabelField(),
    remark: createRemarkField(),
    level: createLevelField(),
  };
}

module.exports = (s) => {
  const config = createAddFormConfig();
  config.parent_game_id.on.getValue = (value) => {
    s.dialog_config.form_config.parent_game_id.value = value;
  };
  return config;
};
module.exports.createAddFormConfig = createAddFormConfig;
module.exports.createEditFormConfig = createEditFormConfig;
